/**
 * Shared anchor utilities for lease document processing.
 * Consumed by:
 *   - Backend: markdown-pdf-renderer.ts (PDF pipeline)
 *   - Frontend: Step8ReviewPreview.tsx (web preview)
 *
 * This ensures the web preview renders anchor tokens identically to the PDF.
 */
/**
 * Regex to match [[TYPE:role]] and [[TYPE:role:label]] anchor tokens.
 */
export const ANCHOR_TOKEN_REGEX = /\[\[(SIGNATURE|DATE|INITIAL|TEXT|CHECKBOX):([^\]:\s]+)(?::([^\]]+))?\]\]/g;
/**
 * Convert [[TYPE:role]] / [[TYPE:role:label]] tokens in a Markdown string
 * to HTML data-attribute elements that render as visual placeholders.
 *
 * Output HTML uses CSS classes from lease-document.css:
 *   - .signature-anchor[data-token]  — SIGNATURE, DATE, INITIAL tokens
 *   - .anchor-token                  — invisible raw token text inside anchors
 *   - .text-anchor[data-token]       — TEXT tokens
 *   - .text-anchor-label             — display label inside TEXT anchor
 *   - .checkbox-anchor[data-token]   — CHECKBOX tokens
 */
export function convertAnchorsToHtml(markdown) {
    // Reset regex state (shared regex with /g flag must be reset between calls)
    ANCHOR_TOKEN_REGEX.lastIndex = 0;
    return markdown.replace(ANCHOR_TOKEN_REGEX, (match, type, role, label) => {
        if (type === 'CHECKBOX') {
            return `<span class="checkbox-anchor" data-token="${type}:${role}"><span class="anchor-token">${match}</span></span>`;
        }
        if (type === 'TEXT') {
            const displayLabel = label ?? role;
            return `<div class="text-anchor" data-token="${type}:${role}"><span class="text-anchor-label">${displayLabel}</span><span class="anchor-token">${match}</span></div>`;
        }
        // SIGNATURE, DATE, INITIAL
        return `<span class="signature-anchor" data-token="${type}:${role}"><span class="anchor-token">${match}</span></span>`;
    });
}
//# sourceMappingURL=anchor-utils.js.map